import { Mail, Percent, Phone, Save, TrendingUp } from 'lucide-react'
import { formatCurrency } from '@/utils/format-currency'
import { isRocketInstance } from '@/config/instanceProfile'
import { PARTNER_COMMISSION_MODE_LABEL } from '@/components/Partners/Modals/partnerDetailModalConstants'
import type { Partner } from '@/types'

interface PartnerDetailOverviewTabProps {
  partner: Partner
}

export function PartnerDetailOverviewTab({ partner }: PartnerDetailOverviewTabProps) {
  return (
    <div className='space-y-6'>
      <div className='grid grid-cols-3 gap-4'>
        <div className='glass-card p-4'>
          <p className='text-[var(--font-color-label)] uppercase tracking-wider font-medium mb-1' style={{ fontSize: 'var(--font-size-label)' }}>
            Forecast
          </p>
          <p className='text-xl font-bold text-[var(--font-color-body)]'>
            {formatCurrency(partner.stats?.totalForecast ?? 0)}
          </p>
        </div>
        <div className='glass-card p-4 bg-amber-500/5'>
          <p className='text-[var(--font-color-label)] uppercase tracking-wider font-medium mb-1' style={{ fontSize: 'var(--font-size-label)' }}>
            A Pagar
          </p>
          <p className='text-xl font-bold text-amber-500'>
            {formatCurrency(partner.stats?.totalToPay ?? 0)}
          </p>
        </div>
        <div className='glass-card p-4 bg-emerald-500/5'>
          <p className='text-[var(--font-color-label)] uppercase tracking-wider font-medium mb-1' style={{ fontSize: 'var(--font-size-label)' }}>
            Total Pago
          </p>
          <p className='text-xl font-bold text-emerald-500'>
            {formatCurrency(partner.stats?.totalPaid ?? 0)}
          </p>
        </div>
      </div>

      <div className='grid grid-cols-2 gap-4'>
        <div className='glass-card p-4 space-y-4'>
          <h4 className='text-[var(--font-color-label)] uppercase tracking-wider font-medium' style={{ fontSize: 'var(--font-size-label)' }}>
            Informações de Contato
          </h4>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-lg bg-[var(--glass-bg)] flex items-center justify-center'>
              <Mail size={14} className='text-[var(--text-muted)]' />
            </div>
            <div>
              <p className='text-[var(--font-color-muted)] text-[11px] uppercase'>E-mail</p>
              <p className='text-[var(--font-color-body)] text-sm font-medium'>{partner.email ?? 'Não informado'}</p>
            </div>
          </div>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-lg bg-[var(--glass-bg)] flex items-center justify-center'>
              <Phone size={14} className='text-[var(--text-muted)]' />
            </div>
            <div>
              <p className='text-[var(--font-color-muted)] text-[11px] uppercase'>Telefone</p>
              <p className='text-[var(--font-color-body)] text-sm font-medium'>{partner.telefone ?? 'Não informado'}</p>
            </div>
          </div>
        </div>

        <div className='glass-card p-4 space-y-4'>
          <h4 className='text-[var(--font-color-label)] uppercase tracking-wider font-medium' style={{ fontSize: 'var(--font-size-label)' }}>
            Dados para Faturamento
          </h4>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-lg bg-[var(--glass-bg)] flex items-center justify-center'>
              <Save size={14} className='text-[var(--text-muted)]' />
            </div>
            <div>
              <p className='text-[var(--font-color-muted)] text-[11px] uppercase'>CNPJ / CPF</p>
              <p className='text-[var(--font-color-body)] text-sm font-medium'>{partner.cnpj ?? 'Não informado'}</p>
            </div>
          </div>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-lg bg-[var(--glass-bg)] flex items-center justify-center'>
              <TrendingUp size={14} className='text-[var(--text-muted)]' />
            </div>
            <div>
              <p className='text-[var(--font-color-muted)] text-[11px] uppercase'>Chave PIX</p>
              <p className='text-[var(--font-color-body)] text-sm font-medium'>{partner.chavePix ?? 'Não informada'}</p>
            </div>
          </div>
          {isRocketInstance && (
            <div className='flex items-center gap-3'>
              <div className='w-9 h-9 rounded-lg bg-[var(--glass-bg)] flex items-center justify-center'>
                <Percent size={14} className='text-[var(--text-muted)]' />
              </div>
              <div>
                <p className='text-[var(--font-color-muted)] text-[11px] uppercase'>Comissionamento</p>
                <p className='text-[var(--font-color-body)] text-sm font-medium'>
                  {PARTNER_COMMISSION_MODE_LABEL[partner.modoComissao ?? 'RECORRENTE']}
                  {(partner.modoComissao ?? 'RECORRENTE') === 'RECORRENTE' && ` · ${Number(partner.comissao)}%`}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
